<template>
  <v-tab-item>
    <v-data-table
      :headers="headers"
      :items="items"
      no-data-text="登録されたグレードはありません"
      sort-by="order"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>グレード編集</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!--ダイアログ-->
          <v-dialog v-model="dialog" max-width="400px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                >グレード追加</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.order"
                        label="ID(並び順)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.grade"
                        label="グレード"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <p>グレードカラー</p>
                      <v-color-picker
                        v-model="editedItem.color"
                        class="ma-2"
                        show-swatches
                      ></v-color-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close"
                  >キャンセル</v-btn
                >
                <v-btn color="blue darken-1" text @click="save">保存</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.color`]="{ item }"> 
        <v-btn :color="item.color" small></v-btn>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-tab-item>
</template>

<script>
/* eslint-disable no-console */
import { db } from "../../plugins/firebase";
import firebase from "../../plugins/firebase";
import CommonMethods from "@/mixins/CommonMethods.js";
import moment from "moment";
export default {
  mixins: [CommonMethods],
  watch: {
    grades() {
      if (this.grades.length <= 0) return;

      this.items = this.grades.map((value) => {
        if (typeof value.create_at !== "object") return value;
        // 作成日成形
        value.create_at = moment(value.create_at.toDate()).format("YYYY/MM/DD");
        // 表示換算
        if (value.grade < 1) {
          value.grade = (value.grade * -1) + "D";
        }
        return value;
      });
    },
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "グレード作成" : "グレード編集";
    },
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: "ID", align: "start", value: "order" },
        { text: "グレード", value: "grade", sortable: false },
        { text: "カラー", value: "color", sortable: false },
        { text: "作成日", value: "create_at", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      items: [],
      grades: [],
      editedIndex: -1,
      editedItem: {
        grade: "0",
        order: 0,
        color: "#FFFFFF",
      },
      defaultItem: {
        grade: "0",
        order: 0,
        color: "#FFFFFF",
      },
    };
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.grades.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      confirm("このアイテムを削除してもよろしいですか？") &&
        this.delete("M_GRADE", item.id);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      // 更新の場合
      if (this.editedIndex > -1) {
        const obj = this.grades[this.editedIndex];
        obj.grade = Number(this.editedItem.grade);
        obj.order = Number(this.editedItem.order);
        obj.color = this.editedItem.color;

        this.update("M_GRADE", obj.id, obj);
        this.$emit("alert", {
          type: "success",
          message: "グレードを更新しました！",
        });
      } else {
        // 新規作成の場合
        try {
          var ref = db.collection("M_GRADE").doc();
          const id = ref.id;
          var grade = {
            id: id,
            grade: Number(this.editedItem.grade),
            order: Number(this.editedItem.order),
            color: this.editedItem.color,
            create_at: firebase.firestore.Timestamp.now(),
          };
          // 登録
          this.create("M_GRADE", grade, id);
          this.$emit("alert", {
            type: "success",
            message: "グレードを登録しました！",
          });
        } catch (err) {
          console.log(err);
          this.$emit("alert", { type: "error", message: err });
        }
      }
      this.close();
    },
  },
  firestore() {
    return {
      grades: db.collection("M_GRADE"),
    };
  },
};
</script>
